import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { makeStyles } from 'tss-react/mui';

const sizeValueMapping = {
    small: 4,
    medium: 6,
    large: 8,
};
const useBoxedImgStyle = makeStyles()((theme, { size, imgPosition }) => {
    const computedSize = theme.spacing(sizeValueMapping[size]);
    return {
        BoxedImg: {
            borderRadius: theme.shape.borderRadiusS,
            width: computedSize,
            height: computedSize,
            objectFit: 'cover',
            objectPosition: imgPosition,
        },
    };
});

const BoxedImg = (_a) => {
    var { size = 'medium', src, className, imgPosition = 'center' } = _a, rest = __rest(_a, ["size", "src", "className", "imgPosition"]);
    const { classes, cx } = useBoxedImgStyle({ size, imgPosition });
    return jsx("img", Object.assign({ src: src, className: cx(classes.BoxedImg, className) }, rest));
};

export { BoxedImg as B };
//# sourceMappingURL=BoxedImg-fedbb73b.js.map
